import { getAll } from '@/api/supportCommercial/index';
import store from '@/store/store';
import messageErreur from '@/services/general/messageErreur';
import i18n from '@/i18n';
import router from '@/router';

export default async function getSupportCommercial(categorieVente) {
  const societeId = store.getters['societe/societeActiveId'];
  const params = { query: { societeId: societeId } };
  const supportCommerciaux = (await getAll(params)).data.result.items;
  const supportCommercial = supportCommerciaux.find((support) => {
    return support.categorieVente === categorieVente;
  });
  if (supportCommercial) return supportCommercial;
  messageErreur(i18n);
  return router.push({ name: 'home' });
}
